<template>
  <div class="dropdown d-inline">
    <Button id="importLogTypeFilter" color="primary" :title="$t('key_filter_log_type')" class="dropdown-toggle ms-2" :variant="logTypeSelected == '' ? 'outline' : 'fill'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-tags me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="importLogTypeFilter">
      <li>
        <button class="dropdown-item border-radius-md text-error" :class="[filterLogTypeSelected=='ERROR'?'active-item':'']" type="button" @click="handleClick('ERROR')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-xmark me-3 text-error"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_log_type_error') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-warning" :class="[filterLogTypeSelected=='WARNING'?'active-item':'']" type="button" @click="handleClick('WARNING')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-triangle-exclamation me-3 text-warning"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_log_type_warning') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-success" :class="[filterLogTypeSelected=='OK'?'active-item':'']" type="button" @click="handleClick('OK')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-check me-3 text-success"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_log_type_ok') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../../generic_components/Button.vue";

  export default {
    name: "ImportLogTypeFilter",
    components: {
      Button
    },
    props: {
      filterLogTypeSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['log-type-filter-change'],
    data() {
      return {
        logTypeSelected: ''
      }
    },
    watch: {
      filterLogTypeSelected() {
        this.logTypeSelected = this.filterLogTypeSelected;
      }
    },
    methods: {
      handleClick(logType) {
        this.logTypeSelected = logType;
        this.$emit('log-type-filter-change', logType);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }
  }

</script>
